import type { KybStepCode, KybStepStatus } from '~/api/kyb/types'

export const KYB_STEP_CODES: KybStepCode[] = [
  'BUSINESS_DETAILS',
  'ACCOUNT_REQUESTER_DETAILS',
  'LEGAL_REPRESENTATIVE_DETAILS',
  'PRIMARY_BENEFICIAL_OWNER_DETAILS',
  'LETTER_OF_AUTHORIZATION',
] as const

export const KYB_STEP_STATUS: Record<KybStepStatus, KybStepStatus> = {
  TODO: 'TODO',
  DONE: 'DONE',
  ERROR: 'ERROR',
} as const
